import { render } from "./Preloader.vue?vue&type=template&id=33707ba2"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"

import "./Preloader.vue?vue&type=style&index=0&id=33707ba2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__